import clsx from 'clsx'
import { Button, Search } from 'components/common'

export interface ProductSearchProps {
  onOk?: () => void
}

export const ProductSearch = (props: ProductSearchProps): JSX.Element => (
  <>
    <div className={clsx('flex', 'justify-start', 'items-center')}>
      <Search placeholder="施設を検索する" />
      <Button className={clsx('ml-2')}>閲覧する</Button>
    </div>
  </>
)
